<template>
    <div class="d-flex flex-column h-100">
        <b-row>
            <b-col cols="12">
                <b-form-group :label="$t('enps.form.researchName')" label-class="title-row">
                    <b-form-input
                        :placeholder="$t('enps.form.typeNameForEnpsResearch')"
                        :disabled="isResearchApplied()"
                        v-model="$v.form.name.$model"
                        :state="checkState('name')"
                    />
                </b-form-group>
            </b-col>

            <b-col>
                <b-form-group :label="$t('enps.form.acceptResponsesUntilDate')" label-class="title-row">
                    <v-date-picker
                        v-model="$v.form.endDate.$model"
                        mode="dateTime"
                        nav-visibility="click"
                        :popover="{ visibility: 'click' }"
                        :showDayPopover="false"
                        show-caps
                        is24hr
                    >
                        <template v-slot="{ inputValue, inputEvents }">
                            <b-form-input
                                :value="inputValue"
                                :state="checkState('endDate')"
                                v-on="inputEvents"
                                :placeholder="$t('enps.date')"
                            />
                        </template>
                    </v-date-picker>
                </b-form-group>
            </b-col>
        </b-row>

        <div class="ml-auto mt-auto">
            <b-button variant="outline-primary" class="mr-2" :disabled="isSubmitting" @click="onClickCancel">{{
                $t('form.button.cancel')
            }}</b-button>
            <button-loader variant="primary" :disabled="isSubmitting" :loader="isSubmitting" @click="onClickSubmit">
                {{ $t('form.button.save') }}
            </button-loader>
        </div>
    </div>
</template>

<script>
import i18n from '@/i18n'
import { setupCalendar, DatePicker as VDatePicker } from 'v-calendar'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import ButtonLoader from '../../../components/button-loader'
import { getDateWithTime } from '@/lib/date'

setupCalendar({
    locale: i18n.locale,
    navVisibility: 'focus',
    popoverDirection: 'bottom',
    popoverVisibility: 'focus',
    popoverAlign: 'right',
})

export default {
    mixins: [validationMixin],
    components: {
        VDatePicker,
        ButtonLoader,
    },
    props: {
        isSubmitting: false,
        research: {
            type: Object,
            default: null,
        },
    },
    validations: {
        form: {
            name: {
                required,
            },
            endDate: {
                required,
            },
            departments: {
                required,
            },
        },
    },
    data() {
        return {
            form: {
                name: null,
                endDate: null,
                departments: [],
            },
        }
    },
    mounted() {
        if (this.research !== null) {
            this.form = this.parseResearchToForm(this.research)
        }
    },
    methods: {
        onClickSubmit() {
            if (this.$v.form.$invalid) {
                return
            }

            const data = this.getFormData()
            this.$emit('submit', data)
        },
        getFormData() {
            this.research.title = this.$v.form.name.$model
            this.research.expired_date = this.parseExpiredDate()
            this.research.teams = this.parseDepartments()
            this.research.applied = false

            return this.research
        },
        parseExpiredDate() {
            return getDateWithTime(this.$v.form.endDate.$model)
        },
        parseDepartments() {
            return this.$v.form.departments.$model.map((d) => d.value)
        },
        parseResearchToForm({ title, expired_date, teams }) {
            return {
                name: title,
                endDate: new Date(expired_date),
                departments: teams.map((t) => ({ value: t.id, label: t.name })),
            }
        },
        checkState(val) {
            const field = this.$v.form[val]
            return field.$dirty ? !field.$invalid : null
        },
        onClickCancel() {
            this.$emit('cancel')
        },
        isResearchApplied() {
            if (!this.research) {
                return false
            }
            return this.research.applied
        },
    },
}
</script>

<style lang="scss" scoped>
.label-style {
    color: #3b3f4e;
    font-size: 16px;
    font-weight: 700;
}

::v-deep legend {
    @extend .label-style;
}

::v-deep label {
    @extend .label-style;
}
</style>
